<div class="card">
  <div class="card-title my-3">
    <h2 class="d-inline-block m-0 mr-3">{{ 'NATIVE_FIELDS.pay_by_card' | alpitranslate }}</h2>
    <small class="d-inline-block p-1">
      @for (method of acceptedCards; track method) {
        <img
          class="mx-1"
          [src]="method | paymentMethodImage | platformasset: true"
          height="20"
          [attr.data-test]="'paymentMehtodIcon-' + method" />
      }
    </small>
  </div>

  <form>
    <div
      class="mb-2 p-0 px-2 form-control-holder"
      [ngClass]="{
        focus: focusedField === 'fields-holder-name',
        error: errorFields.has('fields-holder-name')
      }">
      <div [id]="cardHolderSelector" class="form-control" data-test="cardHolder"></div>
      <label [attr.for]="cardHolderSelector" class="form-label">{{
        'NATIVE_FIELDS.card_holder' | alpitranslate
      }}</label>
    </div>
    <div
      class="mb-2 p-0 px-2 form-control-holder"
      [ngClass]="{
        focus: focusedField === 'fields-card-number',
        error: errorFields.has('fields-card-number')
      }">
      <div [id]="cardNumberSelector" class="form-control" data-test="cardNumber"></div>
      <label [attr.for]="cardNumberSelector" class="form-label">{{
        'NATIVE_FIELDS.card_number' | alpitranslate
      }}</label>
    </div>
    <div class="d-flex mb-1">
      <div
        class="d-inline-block d-sm-block col-sm-3 p-0 px-2 form-control-holder"
        [ngClass]="{
          focus: focusedField === 'fields-expiration',
          error: errorFields.has('fields-expiration')
        }">
        <div [id]="expirationSelector" class="form-control" data-test="cardExpiration"></div>
        <label [attr.for]="expirationSelector" class="form-label">{{
          'NATIVE_FIELDS.validity' | alpitranslate
        }}</label>
      </div>
      <div
        class="d-inline-block d-sm-block col-sm-3 p-0 px-2 form-control-holder"
        [ngClass]="{ focus: focusedField === 'fields-cvc', error: errorFields.has('fields-cvc') }">
        <div [id]="cvcSelector" class="form-control" data-test="cardCvc"></div>
        <label [attr.for]="cvcSelector" class="form-label">{{ 'NATIVE_FIELDS.cvc' | alpitranslate }}</label>
        <small class="hint" [appTooltip]="toolTipContent"> <app-icon name="infoCircle" class="mr-1" /></small>
        <ng-template #toolTipContent>
          <div>{{ 'NATIVE_FIELDS.cvc_message' | alpitranslate }}</div>
        </ng-template>
      </div>
    </div>
    @if (initializingNativeFields()) {
      <div class="text-center mx-auto p-3 d-flex justify-content-center align-items-center loading">
        <div class="alpi-loading-indicator" data-test="alpi-loading-indicator">
          <div class="text-center">
            <div class="spinner-border" role="status"></div>
          </div>
        </div>
      </div>
    }
  </form>
  <small class="d-block text-right pt-1">
    <app-icon
      name="lock"
      class="mr-1"
      style="vertical-align: top"
      [attr.data-test]="'paymentProvider-' + config.provider" />
    {{ 'NATIVE_FIELDS.secured_by' | alpitranslate }}
    @if (config.provider === 'hipay') {
      <app-icon
        [name]="'hipay'"
        class="ml-1"
        style="width: 4rem !important; vertical-align: middle"
        data-test="hipayPaymentProviderIcon" />
    }
    @if (config.provider === 'saferpay') {
      <app-icon
        [name]="'wordline'"
        class="ml-1"
        style="width: 4rem !important; vertical-align: middle"
        data-test="wordlinePaymentProviderIcon" />
    }
  </small>
</div>
